
import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { getExistingCategories } from "@/services/business/categoryService";
import { Skeleton } from "@/components/ui/skeleton";
import { formatCategoryDisplay } from "@/services/business/categoryService";

interface CategoryFilterProps {
  activeCategory: string | undefined;
  setActiveCategory: (category: string | undefined) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({ activeCategory, setActiveCategory }) => {
  const [availableCategories, setAvailableCategories] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categories = await getExistingCategories();
        setAvailableCategories(categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (isLoading) {
    return (
      <div className="pb-6">
        <h3 className="text-lg font-medium mb-4">Categories</h3>
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-9 w-16" />
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-9 w-28" />
        </div>
      </div>
    );
  }

  return (
    <div className="pb-6">
      <h3 className="text-lg font-medium mb-4">Categories</h3>
      <div className="flex flex-wrap gap-2">
        <Button
          key="all"
          variant={activeCategory === undefined ? "default" : "outline"}
          size="sm"
          onClick={() => setActiveCategory(undefined)}
          className={activeCategory === undefined ? "bg-eco-500 hover:bg-eco-600" : ""}
        >
          All
        </Button>
        
        {availableCategories.map((category) => (
          <Button
            key={category}
            variant={activeCategory === category ? "default" : "outline"}
            size="sm"
            onClick={() => setActiveCategory(category)}
            className={activeCategory === category ? "bg-eco-500 hover:bg-eco-600" : ""}
          >
            {formatCategoryDisplay(category)}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;
